import {GestionCategorieDto, IGestionCatalogueWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class CategoriesAdminResolver implements Resolve<Array<GestionCategorieDto>> {

  constructor(private gestionCatalogueWebServiceClient: IGestionCatalogueWebServiceClient) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    return this.gestionCatalogueWebServiceClient.getCategories();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/administration/categories/admin.categories.resolver.ts